import { ChevronLeftIcon } from "components/lib/Shared/Icons/sflIcons";
import ChangeDocumentsEsignature from "./ChangeDocumentsEsignature";
import DirectorsESignature from "./DirectorsESignature";
import ShareholdersESignature from "./ShareholdersESignature";
import BRSFormsESignature from "./BRSFormsESignature";

/**
 *
 * @param {*} param0
 * @returns
 * ESignatureDocsPreparation component for handling the preparation of e-signature documents.
 * It provides a button to hide the e-signature section and go back to the previous step.
 */
const ESignatureDocsPreparation = ({
  setEsignatureIsSelected,
  eSignatureIsForDirectors,
  eSignatureIsForShareholders,
  eSignatureIsForUploadChangeDocs,
  eSignatureIsForAdmin,
  goToPrevStep,
  handleConfirmDetails,
}) => {
  /** Hide E-Signature section */
  const hideESignatureSection = () => {
    setEsignatureIsSelected(false);
  };

  return (
    <div>
      {eSignatureIsForDirectors ? (
        <DirectorsESignature handleConfirmDetails={handleConfirmDetails} />
      ) : eSignatureIsForShareholders ? (
        <ShareholdersESignature handleConfirmDetails={handleConfirmDetails} />
      ) : eSignatureIsForUploadChangeDocs ? (
        <ChangeDocumentsEsignature
          handleConfirmDetails={handleConfirmDetails}
          goToPrevStep={goToPrevStep}
        />
      ) : eSignatureIsForAdmin ? (
        <BRSFormsESignature
          handleConfirmDetails={handleConfirmDetails}
          goToPrevStep={goToPrevStep}
        />
      ) : null}
      {/* Hide E-Signature section */}
      {
        !eSignatureIsForUploadChangeDocs && (<div>
          <button
            onClick={hideESignatureSection}
            className="flex items-start float-left py-2 font-semibold rounded text-primary mt-7"
          >
            <span className="flex items-center mr-4 h-7">
              <ChevronLeftIcon
                className="flex-shrink-0 w-5 h-5"
                aria-hidden="true"
              />
            </span>
            <p className="font-semibold">Go back</p>
          </button>
        </div>)
      }

    </div>
  );
};

export default ESignatureDocsPreparation;
